<template>
    <!-- 智慧区块链 -->
    <productSchema :config="config"></productSchema>
</template>

<script>
import { config } from './js/index'
import productSchema from '../common/product_schema.vue'
export default {
    name: '',
    components: { productSchema },
    data() {
        return {
            config: config,
        };
    },
    computed: {
    },
    watch: {
    },
    mounted(){
    },
    methods: {

    },
};
</script>

<style scoped lang="less">
.odr {}
</style>
